import { Controller } from "@hotwired/stimulus"
import { useMutation, useIntersection } from "stimulus-use"

// Connects to data-controller="scroll"
export default class Scroll extends Controller {
  static newListingsMessage;
  static isAtBottom = true;

  connect() {
    useMutation(this, {
      childList: true,
      subtree: true,
    })

    useIntersection(this, {
      threshold: "0.90"
    })

    Scroll.isAtBottom = false;
    this.scrollToBottom()
  }

  mutate(entries) {
    if (Scroll.isAtBottom) {
      for (const mutation of entries) {
        if (mutation.type === 'childList') {
          this.scrollToBottom()
        }
      }
    }
  }

  appear(entry, observer) {
    // callback automatically triggered when the element
    // intersects with the viewport (or root Element specified in the options)
    Scroll.isAtBottom = true;
  }

  disappear(entry, observer) {
    // callback automatically triggered when the element
    // leaves the viewport (or root Element specified in the options)
    Scroll.isAtBottom = false;
  }

  scrollToBottom() {
    setTimeout(() => {
      Scroll.newListingsMessage = document.getElementById("new_listings_message");
      if (Scroll.newListingsMessage) {
        Scroll.newListingsMessage.scrollIntoView(false)
      }
    }, 500);
  }
}
